import { useEffect, useState } from "react";
import getPost from "../Services/requests/getPost";
import usePopupCtx from "./usePopupCtx";

const usePost = (toGet, slug) => {
	const [post, setPost] = useState(undefined);
	const [loading, setLoading] = useState(true);
	const popUpCtx = usePopupCtx();

	useEffect(() => {
		getPost(toGet, slug)
			.then((newPost) => {
				console.log(newPost);
				setPost(newPost);
				setLoading(false);
			})
			.catch((e) =>
				popUpCtx.showPopUp({
					message: `Ha ocurrido un error, por favor intente más tarde`,
				})
			);;
		// eslint-disable-next-line
	}, [slug]);
	return {post, loading};
};

export default usePost;
